import { render, staticRenderFns } from "./DialogCreateRFQ2.vue?vue&type=template&id=05197a19&"
import script from "./DialogCreateRFQ2.vue?vue&type=script&lang=js&"
export * from "./DialogCreateRFQ2.vue?vue&type=script&lang=js&"
import style0 from "./DialogCreateRFQ2.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports